import React from 'react';
import './tableRanking.scss';
import useFormatParties from '../../dataProvider/hooks/useFormatParties';
import { getSite } from '../../constants';

const COMPARE_MUNICIPALITIES = new Set([
  '28079', // Madrid
  '08019', // Barcelona
  '08015', // Badalona
  '08101', // L'Hospitalet
  '08187', // Sabadell
  '48020', // Bilbao
  '11012', // Cádiz
  '35016', // Las Palmas de Gran Canaria
  '29067', // Málaga
  '29069', // Marbella
  '30030', // Murcia
  '07040', // Palma de Mallorca
  '20069', // San Sebastián
  '41091', // Sevilla
  '46250', // Valencia
  '47186', // Valladolid
  '01059', // Vitoria
  '50297', // Zaragoza
  '15078', // Santiago de Compostela
  '15030', // A Coruña
  '36057', // Vigo
  '45168' // Toledo
]);
const excludes = [];
const TableRanking = ({
  currentData,
  pastData,
  place,
  year,
  electionNumber,
  electionType,
  placeId,
  titleColumn,
  titleColumn2
}) => {
  const partyFormats = useFormatParties(
    currentData,
    pastData,
    year,
    electionNumber,
    electionType,
    placeId,
    excludes,
    getSite()
  );

  if (!partyFormats) {
    return <div>Cargando...</div>;
  }

  const isValid = !place ? true : COMPARE_MUNICIPALITIES.has(place);

  // Return only parties with seats
  const partiesResult = partyFormats.filter(
    item => item.seats > 0 || item.id === 4 // 4 is the id of Ciudadanos
  );

  return (
    <div className="tableRankingScrollContent">
      <div className="tableRankingScroll">
        <div className="tableRanking">
          <table summary="Escaños por partido.">
            <thead>
              <tr>
                <th className="partido" />
                <th className="year year_current">{titleColumn}</th>
                {isValid && <th className="year year_last">{titleColumn2}</th>}
              </tr>
            </thead>
            <tbody>
              {partyFormats &&
                partiesResult &&
                partiesResult.map(party => (
                  <tr key={party.id}>
                    <td
                      className="partyName"
                      style={{ backgroundColor: party.partyColor }}
                    >
                      <h3 className="partyName_title">
                        {`${party.partyAcronym}${party.id === 43 ? ' *' : ''}`}
                      </h3>
                    </td>
                    <td className="partySeats partySeats_current">
                      {party.seats}
                    </td>
                    {isValid && (
                      <td className="partySeats partySeats_old">
                        <span className={party.symbolClassName}>
                          {Math.abs(party.difference)}
                        </span>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* <p className="table-legend">
        *Los datos de PP y Cs (0 escaños) se representan sumados en 2016
      </p> */}
    </div>
  );
};

export default TableRanking;
